export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyA8DeaCIvB3sPfrieLdEBrrxYeRTweXavc',
    authDomain: 'drfeeltest.firebaseapp.com',
    projectId: 'drfeeltest',
    storageBucket: 'drfeeltest.appspot.com',
    messagingSenderId: '190853071317',
    appId: '1:190853071317:web:43923025df7161c4d3bd5c',
    measurementId: 'G-JSX7SDBEZ9',
  },
  apiBaseUrl: 'https://api-test.drfeel.com/patient',
  apiAdminUrl: 'https://api-admin-test.drfeel.com/api',
  partnerName: 'Ambassador-Program-Family',
  webappBaseUrl: 'https://apptest.drfeel.com',
  contractRef: '5c1421d9-601b-11f1-8853-0242ac130002',
  webRedeemCoupon: 'https://pattest.drfeel.com/riscatta-coupons',
};